// перечисления для фильтров выбора значения таблиц

const TrafficDirectionEnum = { // Направление
    1: "Прямое",
    2: "Обратное",
    3: "Оба"
}

const DefectClassificatorEnum = { // Тип дефектов
    4: "ГОСТ Р 50597",
    5: "ОДМ 218.4.039",
}

const TurnPresenceEnum = { // Вираж
    0: "Нет",
    1: "Да",
}

const IsStrightEnum = { // Тип участка
    0: "Нет",
    1: "Да"
}

const PaymentSystemTypeEnum = { // Взимание платы
    1: "Открытая",
    2: "Закрытая",
    3: "Смешанная"
}

const FeeTechnologyTypeEnum = { // Сбор платы
    1: "Ручная",
    2: "Полуавтомат.",
    3: "Автомат."
}

const StatusEnum = { // Статус участка концентрации ДТП
    1: "Затухающий",
    2: "Ликвидирован",
    3: "Потенциально опасный"
}

const PlacementSideEnum = { // Расположение
    1: "?",
    2: "Справа",
    3: "Слева",
    4: "Над дорогой",
    5: "На правом съезде",
    6: "На левом съезде",
    7: "На разделительной полосе",
    8: "С обеих сторон",
    9: "Поперёк",
    10: "Обратное направление",
    11: "Прямое направление",
    12: "В обоих направлениях",
    13: "На оси",
    14: "Правая кромка дороги",
    15: "Левая кромка дороги",
    16: "Правая кромка правого тротуара",
    17: "Левая кромка правого тротуара",
    18: "Правая кромка левого тротуара",
    19: "Левая кромка левого тротуара",
    20: "Пересечение (Течение отсутствует)",
    21: "Примыкание слева (Течение слева направо)",
    22: "Примыкание справа (Течение справа налево)",
    23: "На основной дороге",
    24: "На оси (Через дорогу)",
    25: "Справа на проезжей части",
    26: "Слева на проезжей части",
    27: "На участке разворота"
}

const IsHollowEnum = { // Модель
    0: "Насыпь",
    1: "Выемка"
}

const IsBermEnum = { // Наличие бермы
    0: "Нет",
    1: "Да"
}

const ForRoadEnum = { // Освещает дорогу
    0: "Нет",
    1: "Да"
}
const HasPavilionEnum = { // Наличие павильона
    0: "Нет",
    1: "Да"
}

const LessIsBetterEnum = {
    0: "Нет",
    1: "Да"
}

export const tableEnums: any = {
    "TrafficDirection": TrafficDirectionEnum,
    "TurnPresence": TurnPresenceEnum,
    "IsStright": IsStrightEnum,
    "PaymentSystemType": PaymentSystemTypeEnum,
    "FeeTechnologyType": FeeTechnologyTypeEnum,
    "PlacementSide": PlacementSideEnum,
    "IsHollow": IsHollowEnum,
    "IsBerm": IsBermEnum,
    "ForRoad": ForRoadEnum,
    "HasPavilion": HasPavilionEnum,
    "DefectClassificator": DefectClassificatorEnum,
    "Status": StatusEnum
}

export const tableBooleanEnums: any = {
    "TurnPresence": TurnPresenceEnum,
    "IsStright": IsStrightEnum,
    "IsBerm": IsBermEnum,
    "ForRoad": ForRoadEnum,
    "HasPavilion": HasPavilionEnum,
    "LessIsBetter": LessIsBetterEnum
}